/* ============================================================================
 * FILTER SYSTEM CONFIGURATION
 * ============================================================================
 * 
 * IMPORTANT: Update these values when copying to a new Shopify site!
 * 
 * Option 1: Use window.filterConfig (recommended)
 *   - Include snippets/filter-config.liquid in your theme before this script
 *   - Values will be automatically loaded from configuration
 * 
 * Option 2: Update values directly below
 *   - Change SHOPIFY_DOMAIN to your store's domain
 *   - Change STOREFRONT_ACCESS_TOKEN to your Storefront API token
 *   - Adjust other values as needed
 * ============================================================================ */

// Shopify API Configuration
// Get from window.filterConfig if available, otherwise use defaults
const CONFIG = window.filterConfig || {};
const SHOPIFY_DOMAIN = CONFIG.shopifyDomain || '1930cd-8f.myshopify.com'; // ⚠️ CHANGE THIS for new site
const API_VERSION = CONFIG.apiVersion || '2023-07';
const STOREFRONT_ACCESS_TOKEN = CONFIG.storefrontAccessToken || 'ad47b31ff49e5f41b2198d96e1b9e1e6'; // ⚠️ CHANGE THIS for new site

// Build GraphQL API URL
const GRAPHQL_API_URL = `https://${SHOPIFY_DOMAIN}/api/${API_VERSION}/graphql.json`;

// Pagination Settings
const PRODUCTS_PER_PAGE = CONFIG.productsPerPage || 16; // Products shown per page
const GRAPHQL_PAGE_SIZE = 250; // Products fetched per GraphQL request (max 250)

// Collection Handle Extraction
// Default: extracts from URL path (e.g., /collections/rings -> "rings")
// Override if your URL structure is different
function getCollectionHandle() {
  if (CONFIG.getCollectionHandle && typeof CONFIG.getCollectionHandle === 'function') {
    return CONFIG.getCollectionHandle();
  }
  return window.location.pathname.split("/")[2];
}

/* ============================================================================
 * END CONFIGURATION
 * ============================================================================ */

var all_products = [],
  filter_products = [];
var currentPage = 1;

const storageVal = localStorage.getItem("filters");
const storageHandle = localStorage.getItem("filter-handle");
const filter_initVal = {
  material: [],
  stones: [],
  stonesDesigner: [],
  price: [],
  designer: [],
  length: [],
  stoneShape: [],
  stoneSize: [],
  diamondColor: [],
  diamondClarity: [],
  certificate: [],
  ringType: [],
  material_band: [],
  gender: [],
  watchMaterial: [],
  movement: [],
  caseSize: [],
  productType: [],
  condition: [],
  earringType: [],
  hangingType: [],
  studSize: [],
};
var selectedFilters = storageVal ? JSON.parse(storageVal) : filter_initVal;

const materialFitlerSelector = '.fiter-material .dropdown-content .parent-option>label>input[type="checkbox"]';

const materialBandsFitlerSelector = '.fiter-material-bands .dropdown-content .parent-option>label>input[type="checkbox"]';

const stonesFitlerSelector = '.fiter-stones .dropdown-content .parent-option>label>input[type="checkbox"]';

const stonesDesignerFitlerSelector = '.fiter-stones-designers .dropdown-content .parent-option>label>input[type="checkbox"]';

const subMenuSelector = '.sub-menu.sub-menu-stones input[type="checkbox"]';

const priceSelector = '.fiter-price .dropdown-content .parent-option>label>input[type="checkbox"]';

const designerSelector = '.fiter-designer .dropdown-content .parent-option>label>input[type="checkbox"]';

const lengthSelector = '.fiter-length .dropdown-content .parent-option>label>input[type="checkbox"]';

const stoneShapeSelector = '.fiter-stone-shape .dropdown-content .parent-option input[type="checkbox"]';

const stoneSizeSelector = '.fiter-stone-size .dropdown-content .parent-option input[type="checkbox"]';

const diamondColorSelector = '.fiter-diamond-color .dropdown-content .parent-option input[type="checkbox"]';

const diamondClaritySelector = '.fiter-diamond-clarity .dropdown-content .parent-option input[type="checkbox"]';

const certificateLabSelector = '.fiter-certificate-lab .dropdown-content .parent-option input[type="checkbox"]';

const ringTypeSelector = '.fiter-ring-type .dropdown-content .parent-option input[type="checkbox"]';

const genderSelector = '.fiter-gender .dropdown-content .parent-option input[type="checkbox"]';

const materialTypeSelector = '.fiter-material-type .dropdown-content .parent-option input[type="checkbox"]';

const movementSelector = '.fiter-movement .dropdown-content .parent-option input[type="checkbox"]';

const caseSizeSelector = '.fiter-case-size .dropdown-content .parent-option input[type="checkbox"]';

const productTypeSelector = '.fiter-product-type .dropdown-content .parent-option input[type="checkbox"]';

const conditionSelector = '.fiter-condition .dropdown-content .parent-option input[type="checkbox"]';

const earringTypeSelector = '.fiter-earring-type .dropdown-content .parent-option>label>input[type="checkbox"]';
const hangingTypeSelector = '.fiter-earring-type .dropdown-content .parent-option .sub-menu input[name="hanging-type"]';
const studSizeSelector = '.fiter-earring-type .dropdown-content .parent-option .sub-menu input[name="stud-size"]';
const earringColoredGemstoneSelector = '.fiter-earring-type .dropdown-content .parent-option .sub-menu input[name="gemstones"]';

// Get collection handle using configuration function
const handle = getCollectionHandle();
fetchAllProducts(handle).then((ps) => {
  all_products = ps;
});

const materalfilters = {
  "White Gold": [
    "10k White Gold",
    "14k White Gold",
    "18k White Gold",
    "19k White Gold",
    "10k White Gold / Rose Gold",
    "14k White Gold / Rose Gold",
    "10k Yellow Gold / White Gold",
    "14k Yellow Gold / White Gold",
    "18k Yellow Gold / White Gold",
    "10k White Gold / Yellow Gold",
    "14k White Gold / Yellow Gold",
    "14k Rose / White / Yellow Gold",
    "18k Rose / White / Yellow Gold",
    "Platinum / 10k White Gold",
    "Platinum / 14k White Gold",
    "Platinum / 18k White Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k White Gold / Black Gold",
    "14k White Gold / 18k White Gold",
    "18k White Gold / Sterling Silver",
    "18k White Gold / Stainless Steel",
    "18k White Gold / Rose Gold",
    "22K White Gold / Sterling Silver",
    "14K White Gold / Sterling Silver",
    "18k White Gold / 18k Yellow Gold / 18k Rose Gold / Sterling Silver",
    "18K Oxidized Gold",
    "Titanium / 14K White Gold",
    "10K Oxidized Gold",
  ],
  "Yellow Gold": [
    "9k Yellow Gold",
    "10k Yellow Gold",
    "12k Yellow Gold",
    "14k Yellow Gold",
    "18k Yellow Gold",
    "19k Yellow Gold",
    "20k Yellow Gold",
    "21k Yellow Gold",
    "22k Yellow Gold",
    "23k Yellow Gold",
    "24k Yellow Gold",
    "10k Yellow Gold / White Gold",
    "14k Yellow Gold / White Gold",
    "18k Yellow Gold / White Gold",
    "10k White Gold / Yellow Gold",
    "14k White Gold / Yellow Gold",
    "18k Yellow Gold / Rose Gold",
    "14k Yellow Gold / Silver",
    "18k Yellow Gold / Silver",
    "14k Rose / White / Yellow Gold",
    "14k Yellow Gold / Stainless Steel",
    "18k Rose / White / Yellow Gold",
    "18k Yellow Gold / Rhodium Coated",
    "Titanium / 18k Yellow Gold",
    "22k Yellow Gold / Sterling Silver",
    "18k Yellow Gold / Sterling Silver",
    "14k Yellow Gold / Sterling Silver",
    "Platinum / 18k Yellow Gold",
    "Platinum / 14k Yellow Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k Yellow Gold / 14k Yellow Gold",
    "22k Yellow Gold / 14k Yellow Gold",
    "18k Yellow Gold / 22k Yellow Gold",
    "18k Yellow Gold / Platinum",
    "24K Yellow Gold / Oxidized Silver",
    "22K Yellow Gold / Oxidized Silver",
    "18K Yellow Gold / Mother of Pearl",
    "24K GOLD",
    "18K Yellow Gold / Blue Resin / Ruby",
    "18K Yellow Gold / Briarwood",
    "18k White Gold / 18k Yellow Gold / 18k Rose Gold / Sterling Silver",
    "18K Oxidized Gold",
    "24K Gold / Damascus Steel",
    "10K Oxidized Gold",
    "Enamel / 14K Yellow Gold",
  ],
  Platinum: [
    "Platinum / 10k White Gold",
    "Platinum / 14k White Gold",
    "Platinum / 18k White Gold",
    "Platinum / 18k Yellow Gold",
    "Platinum / 14k Yellow Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "Platinum",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k Yellow Gold / Platinum",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "Platinum and Stainless Steel",
    "Platinum / Rose Gold",
  ],
  "All Gold Types": [
    "9k Yellow Gold",
    "10k Yellow Gold",
    "12k Yellow Gold",
    "14k Yellow Gold",
    "18k Yellow Gold",
    "19k Yellow Gold",
    "20k Yellow Gold",
    "21k Yellow Gold",
    "22k Yellow Gold",
    "23k Yellow Gold",
    "24k Yellow Gold",
    "10k Yellow Gold / White Gold",
    "14k Yellow Gold / White Gold",
    "18k Yellow Gold / White Gold",
    "10k White Gold / Yellow Gold",
    "14k White Gold / Yellow Gold",
    "18k Yellow Gold / Rose Gold",
    "14k Yellow Gold / Silver",
    "18k Yellow Gold / Silver",
    "14k Rose / White / Yellow Gold",
    "14k Yellow Gold / Stainless Steel",
    "18k Rose / White / Yellow Gold",
    "18k Yellow Gold / Rhodium Coated",
    "Titanium / 18k Yellow Gold",
    "22k Yellow Gold / Sterling Silver",
    "18k Yellow Gold / Sterling Silver",
    "14k Yellow Gold / Sterling Silver",
    "Platinum / 18k Yellow Gold",
    "Platinum / 14k Yellow Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k Yellow Gold / 14k Yellow Gold",
    "22k Yellow Gold / 14k Yellow Gold",
    "18k Yellow Gold / 22k Yellow Gold",
    "18k Yellow Gold / Platinum",
    "24K Yellow Gold / Oxidized Silver",
    "22K Yellow Gold / Oxidized Silver",
    "18K Yellow Gold / Mother of Pearl",
    "24K GOLD",
    "18K Yellow Gold / Blue Resin / Ruby",
    "18K Yellow Gold / Briarwood",
    "18k White Gold / 18k Yellow Gold / 18k Rose Gold / Sterling Silver",
    "18K Oxidized Gold",
    "24K Gold / Damascus Steel",
    "10K Oxidized Gold",
    "Enamel / 14K Yellow Gold",
    "10k White Gold",
    "14k White Gold",
    "18k White Gold",
    "10k White Gold / Rose Gold",
    "14k White Gold / Rose Gold",
    "18k White Gold / Black Gold",
    "14k White Gold / 18k White Gold",
    "18k White Gold / Sterling Silver",
    "18k White Gold / Stainless Steel",
    "18k White Gold / Rose Gold",
    "22K White Gold / Sterling Silver",
    "14K White Gold / Sterling Silver",
    "Titanium / 14K White Gold",
    "10k Rose Gold",
    "14k Rose Gold",
    "18k Rose Gold",
    "20k Rose Gold",
    "Titanium / 18k Rose Gold",
    "18k Rose Gold / Sterling Silver",
    "18k Rose Gold / Stainless Steel",
    "Platinum / 10k White Gold",
    "Platinum / 14k White Gold",
    "Platinum / 18k White Gold",
    "Platinum / Rose Gold",
    "14k Black Gold",
    "18k Black Gold",
    "Tri-Tone",
    "Two-Tone",
  ],
  Gold: [
    "9k Yellow Gold",
    "10k Yellow Gold",
    "12k Yellow Gold",
    "14k Yellow Gold",
    "18k Yellow Gold",
    "19k Yellow Gold",
    "20k Yellow Gold",
    "21k Yellow Gold",
    "22k Yellow Gold",
    "23k Yellow Gold",
    "24k Yellow Gold",
    "10k White Gold",
    "14k White Gold",
    "18k White Gold",
    "19k White Gold",
    "10k Rose Gold",
    "14k Rose Gold",
    "18k Rose Gold",
    "20k Rose Gold",
    "14k Black Gold",
    "18k Black Gold",
    "10k White Gold / Rose Gold",
    "14k White Gold / Rose Gold",
    "18k White Gold / Rose Gold",
    "10k Yellow Gold / White Gold",
    "14k Yellow Gold / White Gold",
    "18k Yellow Gold / White Gold",
    "10k White Gold / Yellow Gold",
    "14k White Gold / Yellow Gold",
    "18k Yellow Gold / Rose Gold",
    "14k Yellow Gold / Silver",
    "18k Yellow Gold / Silver",
    "14k Rose / White / Yellow Gold",
    "14k Yellow Gold / Stainless Steel",
    "18k Rose / White / Yellow Gold",
    "Titanium / 18k Rose Gold",
    "Titanium / 18k Yellow Gold",
    "18k Rose Gold / Sterling Silver",
    "22k Yellow Gold / Sterling Silver",
    "18k Yellow Gold / Sterling Silver",
    "14k Yellow Gold / Sterling Silver",
    "Sterling Silver",
    "Platinum / 10k White Gold",
    "Platinum / 18k White Gold",
    "Platinum / 14k Yellow Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k White Gold / Black Gold",
    "14k White Gold / 18k White Gold",
    "18k Yellow Gold / 14k Yellow Gold",
    "22k Yellow Gold / 14k Yellow Gold",
    "18k Yellow Gold / 22k Yellow Gold",
    "18k Yellow Gold / Platinum",
    "18k White Gold / Sterling Silver",
    "14k Yellow Gold / Stainless Steel",
    "Tantalum/Steel",
    "24k Gold",
    "24k Yellow Gold / Oxidized Silver",
    "22K White Gold / Sterling Silver",
    "18K Yellow Gold / Mother of Pearl",
    "14K White Gold / Sterling Silver",
    "18k Yellow Gold / Blue Resin / Ruby",
    "18k Yellow Gold / Briarwood",
    "18K Oxidized Gold",
    "18k White Gold / 18k Yellow Gold / 18k Rose Gold / Sterling Silver",
    "Titanium / 14K White Gold",
    "24K Gold / Damascus Steel",
    "22k Yellow Gold / White Gold",
    "10K Oxidized Gold",
    "Platinum / 18K Rose Gold",
    "Enamel / 14K Yellow Gold",
  ],
  Others: [
    "14k Yellow Gold / Stainless Steel",
    "Gold Toned Steel",
    "Stainless Steel/Sterling Silver",
    "Stainless Steel",
    "18k Rose Gold / Stainless Steel",
    "18k White Gold / Stainless Steel",
    "Tantalum/Steel",
    "Platinum and Stainless Steel",
    "Damascus Steel",
    "Stainless Steel and Titanium",
    "Gold Plated Stainless Steel",
    "Titanium and Damascus Steel",
    "Sterling silver and Damascus steel",
    "Titanium and Elmax steel",
    "Stainless Steel and Damascus Steel",
    "Stainless Steel / Sterling Silver / Carbon Fiber",
    "Aluminium / Stainless Steel",
    "Titanium / Sterling Silver / Damascus Steel",
    "24K Gold / Damascus Steel",
    "Titanium / Maple Burl / Damascus Steel",
    "14k Yellow Gold / Silver",
    "18k Yellow Gold / Silver",
    "Sterling Silver",
    "18k White Gold / Sterling Silver",
    "14k Yellow Gold / Sterling Silver",
    "18k Rose Gold / Sterling Silver",
    "22k Yellow Gold / Sterling Silver",
    "24K Yellow Gold / Oxidized Silver",
    "Oxidized Sterling Silver",
    "Enamel / Sterling Silver",
    "14K White Gold / Sterling Silver",
    "18k White Gold / 18k Yellow Gold / 18k Rose Gold / Sterling Silver",
    "Titanium / 18k Rose Gold",
    "Titanium / 18k Yellow Gold",
    "18k Yellow Gold / Rhodium Coated",
    "Platinum / 10k White Gold",
    "Platinum / 14k White Gold",
    "Platinum / 18k White Gold",
    "Platinum / 18k Yellow Gold",
    "Platinum / 14k Yellow Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k Yellow Gold / Platinum",
    "Platinum / Rose Gold",
    "14k Black Gold",
    "18k Black Gold",
    "Titanium / Tantalum",
    "Tantalum / Bronze",
    "Tantalum / Carbon Fiber",
    "Carbon / Titanium",
    "Mokume",
    "Other",
    "Jade",
    "Horn",
    "White Alligator",
    "Acrylic",
    "Base Metal",
    "Ceratanium",
    "Resin",
    "Lucite",
    "Crystal",
    "Carbon Fiber",
    "Cobalt",
    "Bronze",
    "Platinum",
    "Tungsten",
    "Ceramic",
    "Palladium",
    "Enamel",
    "Black Aluminum",
    "DLC",
    "PVD",
    "Polymer",
    "Aluminum",
    "18k White Gold / Black Gold",
    "Sapphire",
    "18K Yellow Gold / Mother of Pearl",
    "18K Yellow Gold / Blue Resin / Ruby",
    "18K Yellow Gold / Briarwood",
    "Enamel / 14K Yellow Gold",
    "Enamel / 14K White Gold",
  ],
};

const watchMaterialFitlers = {
  "Stainless Steel": [
    "14k Yellow Gold / Stainless Steel",
    "Gold Toned Steel",
    "Stainless Steel/Sterling Silver",
    "Stainless Steel",
    "18k Rose Gold / Stainless Steel",
    "18k White Gold / Stainless Steel",
    "14k Yellow Gold / Stainless Steel",
    "Tantalum/Steel",
    "Platinum and Stainless Steel",
    "Damascus Steel",
    "Stainless Steel and Titanium",
    "Gold Plated Stainless Steel",
    "Titanium and Damascus Steel",
    "Sterling Silver and Damascus Steel",
    "Titanium and Elmax Steel",
    "Stainless Steel and Damascus Steel",
    "Stainless Steel / Sterling Silver / Carbon Fiber",
    "Aluminium / Stainless Steel",
    "Titanium / Sterling Silver / Damascus Steel",
    "24K Gold / Damascus Steel",
    "Titanium / Maple Burl / Damascus Steel",
  ],
  Gold: [
    "9k Yellow Gold",
    "10k Yellow Gold",
    "12k Yellow Gold",
    "14k Yellow Gold",
    "18k Yellow Gold",
    "19k Yellow Gold",
    "20k Yellow Gold",
    "21k Yellow Gold",
    "22k Yellow Gold",
    "23k Yellow Gold",
    "24k Yellow Gold",
    "10k White Gold",
    "14k White Gold",
    "18k White Gold",
    "19k White Gold",
    "10k Rose Gold",
    "14k Rose Gold",
    "18k Rose Gold",
    "20k Rose Gold",
    "14k Black Gold",
    "18k Black Gold",
    "10k White Gold / Rose Gold",
    "14k White Gold / Rose Gold",
    "18k White Gold / Rose Gold",
    "10k Yellow Gold / White Gold",
    "14k Yellow Gold / White Gold",
    "18k Yellow Gold / White Gold",
    "10k White Gold / Yellow Gold",
    "14k White Gold / Yellow Gold",
    "18k Yellow Gold / Rose Gold",
    "14k Yellow Gold / Silver",
    "18k Yellow Gold / Silver",
    "14k Rose / White / Yellow Gold",
    "14k Yellow Gold / Stainless Steel",
    "18k Rose / White / Yellow Gold",
    "Titanium / 18k Rose Gold",
    "Titanium / 18k Yellow Gold",
    "18k Rose Gold / Sterling Silver",
    "22k Yellow Gold / Sterling Silver",
    "18k Yellow Gold / Sterling Silver",
    "14k Yellow Gold / Sterling Silver",
    "Sterling Silver",
    "Platinum / 10k White Gold",
    "Platinum / 18k White Gold",
    "Platinum / 14k Yellow Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k White Gold / Black Gold",
    "14k White Gold / 18k White Gold",
    "18k Yellow Gold / 14k Yellow Gold",
    "22k Yellow Gold / 14k Yellow Gold",
    "18k Yellow Gold / 22k Yellow Gold",
    "18k Yellow Gold / Platinum",
    "18k White Gold / Sterling Silver",
    "14k Yellow Gold / Stainless Steel",
    "Tantalum/Steel",
    "24k Gold",
    "24k Yellow Gold / Oxidized Silver",
    "22k White Gold / Sterling Silver",
    "18k Yellow Gold / Mother of Pearl",
    "14k White Gold / Sterling Silver",
    "18k Yellow Gold / Blue Resin / Ruby",
    "18k Yellow Gold / Briarwood",
    "18k Oxidized Gold",
    "18k White Gold / 18k Yellow Gold / 18k Rose Gold / Sterling Silver",
    "Titanium / 14k White Gold",
    "24k Gold / Damascus Steel",
    "22k Yellow Gold / White Gold",
    "10k Oxidized Gold",
    "Platinum / 18K Rose Gold",
    "Enamel / 14k Yellow Gold",
  ],
  Titanium: [
    "Titanium / 18k Rose Gold",
    "Titanium / 18k Yellow Gold",
    "Titanium",
    "Stainless Steel and Titanium",
    "Titanium and Damascus Steel",
    "Titanium and Elmax Steel",
    "Titanium / Tantalum",
    "Titanium / Sterling Silver / Damascus Steel",
    "24k Gold / Damascus Steel",
    "Titanium / Maple Burl / Damascus Steel",
  ],
  Ceramic: ["Ceramic"],
  Mixed: [
    "14k Yellow Gold / Stainless Steel",
    "18k Yellow Gold / Rhodium Coated",
    "Stainless Steel/Sterling Silver",
    "Titanium / 18k Rose Gold",
    "Titanium / 18k Yellow Gold",
    "18k Rose Gold / Sterling Silver",
    "22k Yellow Gold / Sterling Silver",
    "18k Yellow Gold / Sterling Silver",
    "14k Yellow Gold / Sterling Silver",
    "Platinum / 10k White Gold",
    "Platinum / 14k White Gold",
    "Platinum / 18k White Gold",
    "Platinum / 14k Yellow Gold",
    "Platinum / 18k Yellow Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold",
    "Platinum / 18k Yellow Gold / 18k White Gold / 18k Rose Gold",
    "18k White Gold / Sterling Silver",
    "Platinum and Stainless Steel",
    "Stainless Steel and Titanium",
    "24k Yellow Gold / Oxidized Silver",
    "Titanium and Damascus Steel",
    "Sterling Silver and Damascus Steel",
    "Titanium and Elmax Steel",
    "Stainless Steel and Damascus Steel",
    "Stainless Steel / Sterling Silver / Carbon Fiber",
    "22k Yellow Gold / Oxidized Silver",
    "22k White Gold / Sterling Silver",
    "Enamel / Sterling Silver",
    "22k White Gold / Sterling Silver",
    "18k Yellow Gold / Mother of Pearl",
    "14k White Gold / Sterling Silver",
    "18k Yellow Gold / Blue Resin / Ruby",
    "18k Yellow Gold / Briarwood",
    "18k Oxidized Gold",
    "18k White Gold / 18k Yellow Gold / 18k Rose Gold / Sterling Silver",
    "Titanium / Tantalum",
    "Tantalum / Bronze",
    "Tantalum / Carbon Fiber",
    "Titanium / 14k White Gold",
    "Carbon / Titanium",
    "Aluminium / Stainless Steel",
    "Titanium / Sterling Silver / Damascus Steel",
    "Platinum / 18k Rose Gold",
    "Enamel / 14k Yellow Gold",
  ],
  Other: [
    "Other",
    "Jade",
    "Horn",
    "White Alligator",
    "Acrylic",
    "Base Metal",
    "Ceratanium",
    "Resin",
    "Lucite",
    "Crystal",
    "Carbon Fiber",
    "Cobalt",
    "Bronze",
    "Tri-Tone",
    "Two-Tone",
    "Tungsten",
    "Platinum",
    "Palladium",
    "Enamel",
    "Black Aluminum",
    "DLC",
    "PVD",
    "Polymer",
    "Aluminum",
    "Carbon",
    "Sapphire",
    "Oxidized Sterling Silver",
    "Tantalum",
    "Mokume",
  ],
};

const stoneMisspellings = {
  diamond: ["diamond", "diamonds", "diamon", "diamand", "dimaond"],
  amethyst: ["amethyst", "amethysts", "amathyst", "amathist", "amethyst"],
  aquamarine: ["aquamarine", "aquamarines", "aquamarinne", "aquamarain", "aqumarine"],
  beryl: ["beryl", "beryls", "beryll", "beril", "berly"],
  citrine: ["citrine", "citrines", "citrin", "citrene", "citrine"],
  emerald: ["emerald", "emeralds", "emeral", "emrald", "emereld"],
  garnet: ["garnet", "garnets", "garnett", "garent", "garnet"],
  jade: ["jade", "jades", "jaed", "jadee", "jaid"],
  moissanite: ["moissanite", "moissanites", "moissanite", "moissanite"],
  onyx: ["onyx", "onyxes", "onix", "onyxs", "onix"],
  opal: ["opal", "opals", "opell", "opaal", "opl"],
  "pearl (inclues freshwater pearl)": ["pearl", "pearls", "pearll", "peral", "perl"],
  peridot: ["peridot", "peridots", "peridote", "peridot", "perdote"],
  ruby: ["ruby", "rubies", "rubby", "rubi", "rubey"],
  sapphire: ["sapphire", "sapphires", "saphire", "sapphire", "saphirre"],
  spinel: ["spinel", "spinels", "spinal", "spinell", "spinnel"],
  tanzanite: ["tanzanite", "tanzanites", "tanzinite", "tanzanit", "tanzanitte"],
  topaz: ["topaz", "topazes", "topazz", "topas", "topaz"],
  tourmaline: ["tourmaline", "tourmalines", "tourmaline", "tourmalin", "tourmalene"],
  turquoise: ["turquoise", "turquoises", "turqouise", "turquise", "turqouise"],
  alexandrite: ["alexandrite", "alexandrites", "alexndrite", "alexandrit", "alexzandrite"],
  agate: ["agate", "agates", "agatte", "agat", "agate"],
  abalone: ["abalone", "abalones", "abalone", "abalonie", "abalonee"],
  chrysoprase: ["chrysoprase", "chrysoprases", "chrysophrase", "chrysoprase", "chrysopraze"],
  crystal: ["crystal", "crystals", "crystle", "crystial", "cristal"],
  "dinosaur bone": ["dinosaur bone", "dinosaur bones", "dinosour bone", "dinosaur bon", "dinosaur bones"],
  hematite: ["hematite", "hematites", "hematitt", "hemetite", "hematite"],
  kirinite: ["kirinite", "kirinites", "kirinite", "kirinite", "kirenite"],
  lava: ["lava", "lavas", "lavaa", "lave", "lavaa"],
  "mammoth tooth": ["mammoth tooth", "mammoth teeth", "mammoth toothes", "mammoth teath"],
  "mother of pearl": ["mother of pearl", "mothers of pearl", "mothr of pearl", "mother of pearle"],
  multi: ["multi", "multis", "multie", "multis", "muliti"],
  "oregon sunstone": ["oregon sunstone", "oregon sunstones", "oregan sunstone", "oregon sunstones"],
  "oyster shell": ["oyster shell", "oyster shells", "oysther shell", "oystar shell"],
  sugilite: ["sugilite", "sugilites", "sugillite", "sugelite", "sugilitte"],
  "tiger's eye": ["tiger's eye", "tiger's eyes", "tigers eye", "tiger's eyes", "tiger eye"],
  unakite: ["unakite", "unakites", "unkite", "unakitte", "unikite"],
  meteorite: ["meteorite", "meteorites", "meteoritte", "metiorite"],
  charoite: ["charoite", "charoites", "charoitte", "charorite"],
  ametrine: ["ametrine", "ametrines", "ametrin", "ametrrine", "ametrine"],
  ammolite: ["ammolite", "ammolites", "ammolitt", "ammolit"],
  bloodstone: ["bloodstone", "bloodstones", "bloodstoe", "bloodston"],
  carnelian: ["carnelian", "carnelians", "carenlian", "carnelian"],
  "cat's eye": ["cat's eye", "cat's eyes", "cats eye", "cat's eyes", "cats eyes"],
  chalcedony: ["chalcedony", "chalcedonies", "chalcedony", "chalcedony", "chalcedony"],
  chrysoberyl: ["chrysoberyl", "chrysoberyls", "chrysoberyll", "chrysobery", "chrysbeyrl"],
  "chrome diopside": ["chrome diopside", "chrome diopsides", "chrome dipside", "chrom diopside"],
  coral: ["coral", "corals", "corral", "coral", "corral"],
  "cubic zirconia": ["cubic zirconia", "cubic zirconias", "cubic ziconia", "cubic zirconia"],
  iolite: ["iolite", "iolites", "iolitte", "iolight"],
  jasper: ["jasper", "jaspers", "jaspar", "jaspper"],
  kunzite: ["kunzite", "kunzites", "kunizite", "kunzitt"],
  labradorite: ["labradorite", "labradorites", "labradoritte", "labradorit"],
  lapis: ["lapis", "lapis", "lapis", "lapiz"],
  malachite: ["malachite", "malachites", "malachitte", "malachit"],
  moldavite: ["moldavite", "moldavites", "moldavitte", "moldavite"],
  moonstone: ["moonstone", "moonstones", "moonstoe", "moonston"],
  morganite: ["morganite", "morganites", "morgante", "morganiite"],
  prasiolite: ["prasiolite", "prasiolites", "prasiolitt", "prasiolite"],
  quartz: ["quartz", "quartz", "quarts", "quartze"],
  rhodochrosite: ["rhodochrosite", "rhodochrosites", "rhodochrositte", "rhodochrose"],
  rhodonite: ["rhodonite", "rhodonites", "rhodonitte", "rhodinite"],
  serpentine: ["serpentine", "serpentines", "serpentine", "serpintine"],
  sunstone: ["sunstone", "sunstones", "sunstoe", "sunstone"],
  tsavorite: ["tsavorite", "tsavorites", "tsavorite", "tsavorite"],
  zircon: ["zircon", "zircons", "zircon", "zircon"],
  obsidian: ["obsidian", "obsidian", "obsidian", "obsidian"],
  "kashmir blue": ["kashmir blue", "kashmir blues", "kashmir blue", "kashmir blue"],
  sodalite: ["sodalite", "sodalites", "sodalite", "sodalite"],
};

const stoneFilters = {
  "All others": [
    "Agate",
    "Abalone",
    "Agate",
    "Chrysoprase",
    "Crystal",
    "Dinosaur bone",
    "Hematite",
    "Kirinite",
    "Lava",
    "Mammoth tooth",
    "Mother of pearl",
    "Multi",
    "Oregon sunstone",
    "Other",
    "Oyster shell",
    "Sugilite",
    "Tiger's eye",
    "Unakite",
    "Meteorite",
    "Charoite",
    "Ametrine",
    "Ammolite",
    "Bloodstone",
    "Carnelian",
    "Cat's eye",
    "Chalcedony",
    "Chrysoberyl",
    "Chrome diopside",
    "Coral",
    "Cubic zirconia",
    "Iolite",
    "Jasper",
    "Kunzite",
    "Labradorite",
    "Lapis",
    "Malachite",
    "Moldavite",
    "Moonstone",
    "Morganite",
    "Prasiolite",
    "Quartz",
    "Rhodochrosite",
    "Rhodonite",
    "Serpentine",
    "Sunstone",
    "Tsavorite",
    "Zircon",
    "Obsidian",
    "Kashmir blue",
    "Sodalite",
  ],
  Colored: [
    "Amethyst",
    "Aquamarine",
    "Beryl",
    "Citrine",
    "Emerald",
    "Garnet",
    "Jade",
    "Moissanite",
    "Onyx",
    "Opal",
    "Pearl",
    "Peridot",
    "Ruby",
    "Sapphire",
    "Spinel",
    "Tanzanite",
    "Topaz",
    "Tourmaline",
    "Turquoise",
    "Alexandrite",
  ],
};

const coloredGemstones = [...stoneFilters["Colored"], ...stoneFilters["All others"]];

const diamondColorFitlers = {
  "D-F": ["D", "E", "F", "D-E", "D-F", "E-F"],
  "G-J": ["G", "H", "I", "J", "G-H", "G-I", "G-J", "H-I", "H-J", "I-J", "G-I-J", "G-H-I-J"],
  "K+": ["K", "L", "M", "N", "O", "P", "K-L", "K-M", "K-N", "K-O", "K-P", "L-M", "L-N", "L-O", "L-P", "M-N", "M-O", "M-P", "N-O", "N-P", "O-P"],
  Fancy: [
    "Blue",
    "Ceylon",
    "Deep Royal Blue",
    "Fancy Colored",
    "Fancy Green Yellow",
    "Fancy Light Yellow",
    "Fancy Yellow",
    "Galaxy",
    "Grape",
    "Highly Saturated Deep Kelly Green",
    "Intense Ideal Kelly Green",
    "Intense Fancy Yellow",
    "Kelly Green",
    "London Blue",
    "Natural Pink",
    "Salmon",
    "Shamrock",
    "Tahitian",
    "Santa Maria",
    "Yellow",
    "Fancy Brown Yellow",
    "Irradiated Blue",
    "Red",
    "Light Yellow",
    "White",
  ],
  Brown: ["L-Brown", "TLB", "Brown", "Champagne", "Cognac", "Chocolate", "Fancy Light Brownish Yellow"],
  Black: ["Black"],
};

const diamondClarityFilters = {
  IF: ["IF"],
  VVS: ["VVS1", "VVS2", "VVS", "VVS1-VVS2", "Varies (VS-VVS)", "AAA+"],
  VS: ["VS1", "VS2", "VS", "VS1-VS2", "Varies (SI-VS)", "AAA", "VS2-I1"],
  SI: ["SI1", "SI2", "SI3", "SI", "SI1-SI2", "SI2-SI3", "Varies (I-SI)", "AA", "I-SI"],
  I: ["I1", "I2", "I3", "I1-I2", "I2-I1", "SI3-I1", "SI3-I1", "I-SI"],
};

const stoneMatches = (text, stoneToMatch) => {
  if (!text || !stoneToMatch) {
    return false;
  }

  const stoneVariationsToMatch = [stoneToMatch.toLowerCase(), ...(stoneMisspellings[stoneToMatch.toLowerCase()] || [])];

  return stoneVariationsToMatch.some((variation) => text.toLowerCase().includes(variation));
};

const containsNoStones = (text) => {
  let containsStones = false;

  const gemstones = [...coloredGemstones, ...Object.keys(stoneMisspellings)];
  return stoneMatchesNone(text, gemstones);
};

const containsColoredGemstones = (text) => {
  return stoneMatchesAny(text, coloredGemstones);
};

const stoneIsColoredGemstone = (stone) => {
  if (!stone || typeof stone !== "string") {
    return false;
  }
  return coloredGemstones.some((coloredGemstone) => coloredGemstone.toLowerCase() === stone.toLowerCase());
};

const stoneMatchesAny = (text, stonesToMatch) => {
  if (!text || !stonesToMatch || !Array.isArray(stonesToMatch)) {
    return false;
  }

  return stonesToMatch.some((stone) => stoneMatches(text, stone));
};

const stoneMatchesNone = (text, stonesToMatch) => {
  if (!text || !stonesToMatch || !Array.isArray(stonesToMatch)) {
    return true; // If no text or stones to match, then it's true that none match
  }

  return !stonesToMatch.some((stone) => stoneMatches(text, stone));
};

jQuery(document).ready(function ($) {
  const url = window.location.href;

  $(".custom-filter>button").click(function () {
    // $(".custom-filter>button").not(this).next().hide();
    $(this).next().slideToggle();
  });

  $(".CollectionToolbar__Item").click(function (params) {
    $(".CollectionInner__Sidebar").toggleClass("hidden-pocket");

    $(".CollectionInner .Collapsible__Inner").css("height", "auto").css("visibility", "visible");
  });

  $(priceSelector).change(function () {
    if (this.checked) {
      $(priceSelector).not(this).prop("checked", false);
    }

    //$(this).parents(".dropdown").toggle();

    const values = $(this).val().split("~");
    showOverlay();

    if (this.checked) {
      selectedFilters["price"] = values.map((v) => parseInt(v));
    } else {
      selectedFilters["price"] = [];
    }
    applyFilter();
  });

  $(stonesFitlerSelector).change(function () {
    console.log("stonesFitlerSelector", $(this).val())
    if (this.checked) {
      $(stonesFitlerSelector).not(this).prop("checked", false);
      $(subMenuSelector).prop("checked", false);
    }

    if ($(this).hasClass("has-submenu")) {
      if (this.checked) {
        $(this).parent().next().show();
        if ($(this).val() === "Colored Gemstone") {
          selectedFilters["stones"] = ['Colored Gemstone'];
        }
      } else {
        $(this).parent().next().hide();
        selectedFilters["stones"] = [];
      }
      applyFilter();
      return;
    } else {
      $(".submenu").hide();
    }

    //$(this).parents(".dropdown").toggle();

    showOverlay();

    if (this.checked) {
      console.log("setting stones", $(this).val())
      selectedFilters["stones"] = [$(this).val()];
    } else {
      selectedFilters["stones"] = selectedFilters["stones"].filter((p) => p !== $(this).val());
    }

    applyFilter();
  });

  $(stonesDesignerFitlerSelector).change(function () {
    if (this.checked) {
      $(stonesDesignerFitlerSelector).not(this).prop("checked", false);
    }

    //$(this).parents(".dropdown").toggle();

    showOverlay();

    if (this.checked) {
      selectedFilters["stonesDesigner"] = stoneFilters[$(this).val()] || [$(this).val()];
    } else {
      selectedFilters["stonesDesigner"] = [];
    }
    applyFilter();
  });

  $(subMenuSelector).change(function () {
    var multiSelect = $(this).parents(".sub-menu").hasClass("multi-select");
    if (this.checked) {
      // Uncheck all other checkboxes
      if (!multiSelect) $(subMenuSelector).not(this).prop("checked", false);
    }

    showOverlay();

    const filterVal = stoneFilters[$(this).val()] || [$(this).val()];

    if (this.checked) {
      if (multiSelect) {
        const checkedValues = $('input[name="gemstones"]:checked')
        if (checkedValues.length > 0) {
          var selectedValues = checkedValues
            .map(function () {
              return this.value;
            })
            .get();
          selectedFilters["stones"] = selectedValues;
        } else {
          selectedFilters["stones"] = filterVal;
        }
      } else selectedFilters["stones"] = filterVal;
    } else {
      const checkedValues = $('input[name="gemstones"]:checked')
      if (checkedValues.length > 0) {
        selectedFilters["stones"] = selectedFilters["stones"].filter((p) => !filterVal.includes(p));
      } else {
        selectedFilters["stones"] = ['Colored Gemstone'];
      }
    }
    applyFilter();
  });

  // Material Filter
  $(materialFitlerSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes

      $(materialFitlerSelector).not(this).prop("checked", false);
    }

    //$(this).parents(".dropdown").toggle();

    showOverlay();

    const filterVal = materalfilters[$(this).val()] || [$(this).val()];

    if (this.checked) {
      selectedFilters["material"] = filterVal;
    } else {
      selectedFilters["material"] = selectedFilters["material"].filter((p) => !filterVal.includes(p));
    }
    applyFilter();
  });
  // Material Filter
  $(materialTypeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(materialTypeSelector).not(this).prop("checked", false);
    }

    //$(this).parents(".dropdown").toggle();

    showOverlay();

    const filterVal = watchMaterialFitlers[$(this).val()] || [$(this).val()];

    if (this.checked) {
      selectedFilters["watchMaterial"] = filterVal;
    } else {
      selectedFilters["watchMaterial"] = [];
    }
    applyFilter();
  });
  // Material Band Filter
  $(materialBandsFitlerSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes

      $(materialBandsFitlerSelector).not(this).prop("checked", false);
    }

    //$(this).parents(".dropdown").toggle();

    showOverlay();

    const filterVal = [$(this).val()];
    if (this.checked) {
      selectedFilters["material_band"] = filterVal;
    } else {
      selectedFilters["material_band"] = [];
    }
    applyFilter();
  });

  $(designerSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes

      $(designerSelector).not(this).prop("checked", false);
      //$(this).parents(".dropdown").toggle();

      showOverlay();

      const filterVal = [$(this).val()];

      selectedFilters["designer"] = filterVal;
    } else {
      selectedFilters["designer"] = [];
    }
    applyFilter();
  });

  $(lengthSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes

      $(lengthSelector).not(this).prop("checked", false);
      //$(this).parents(".dropdown").toggle();

      showOverlay();

      const filterVal = [$(this).val()];

      selectedFilters["length"] = filterVal;
    } else {
      selectedFilters["length"] = [];
    }
    applyFilter();
  });

  $(stoneSizeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes

      $(stoneSizeSelector).not(this).prop("checked", false);
      //$(this).parents(".dropdown").toggle();

      showOverlay();

      const filterVal = [$(this).val()];

      selectedFilters["stoneSize"] = filterVal;
    } else {
      selectedFilters["stoneSize"] = [];
    }
    applyFilter();
  });

  $(stoneShapeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes

      showOverlay();
    }
    const filterVal = $(this).val();

    if (this.checked) {
      selectedFilters["stoneShape"].push(filterVal);
    } else {
      selectedFilters["stoneShape"] = selectedFilters["stoneShape"].filter((stone) => stone !== filterVal);
    }
    applyFilter();
  });

  $(diamondColorSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes

      showOverlay();
    }
    const filterVal = diamondColorFitlers[$(this).val()];

    if (this.checked) {
      selectedFilters["diamondColor"] = [...selectedFilters["diamondColor"], ...filterVal];
    } else {
      selectedFilters["diamondColor"] = selectedFilters["diamondColor"].filter((stone) => !filterVal.includes(stone));
    }
    applyFilter();
  });

  $(diamondClaritySelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes

      showOverlay();
    }
    const filterVal = diamondClarityFilters[$(this).val()];

    if (this.checked) {
      selectedFilters["diamondClarity"] = [...selectedFilters["diamondClarity"], ...filterVal];
    } else {
      selectedFilters["diamondClarity"] = selectedFilters["diamondClarity"].filter((stone) => !filterVal.includes(stone));
    }
    applyFilter();
  });

  $(certificateLabSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(certificateLabSelector).not(this).prop("checked", false);
      showOverlay();
    }
    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["certificate"] = filterVal;
    } else {
      selectedFilters["certificate"] = [];
    }
    applyFilter();
  });

  $(ringTypeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(ringTypeSelector).not(this).prop("checked", false);
      showOverlay();
    }
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["ringType"] = filterVal;
      if (filterVal[0] === "Women Wedding" || filterVal[0] === "Men Wedding") {
        $(".filter-price-gender").show();
        $(".filter-price-engagement").hide();
      } else {
        $(".filter-price-gender").hide();
        $(".filter-price-engagement").show();
      }
    } else {
      selectedFilters["ringType"] = [];
      $(".filter-price-engagement").show();
    }
    applyFilter();
  });

  $(genderSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(genderSelector).not(this).prop("checked", false);
      showOverlay();
    }
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["gender"] = filterVal;
    } else {
      selectedFilters["gender"] = [];
    }
    applyFilter();
  });

  $(productTypeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(productTypeSelector).not(this).prop("checked", false);
      showOverlay();
    }
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["productType"] = filterVal;
    } else {
      selectedFilters["productType"] = [];
    }
    applyFilter();
  });

  $(movementSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(movementSelector).not(this).prop("checked", false);
      showOverlay();
    }
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["movement"] = filterVal;
    } else {
      selectedFilters["movement"] = [];
    }
    applyFilter();
  });

  $(caseSizeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(caseSizeSelector).not(this).prop("checked", false);
      showOverlay();
    }
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["caseSize"] = filterVal;
    } else {
      selectedFilters["caseSize"] = [];
    }
    applyFilter();
  });

  $(conditionSelector).change(function () {
    showOverlay();

    const filterVal = $(this).val();

    if (this.checked) {
      selectedFilters["condition"].push(filterVal);
    } else {
      selectedFilters["condition"] = selectedFilters["condition"].filter((condition) => condition !== filterVal);
    }
    applyFilter();
  });

  // Handle submenu visibility for earring type filter
  $(document).on("change", ".fiter-earring-type .has-submenu", function () {
    const $submenu = $(this).closest("label").next(".sub-menu");

    // Hide all other submenus first
    $(".fiter-earring-type .sub-menu").not($submenu).hide();

    if (this.checked) {
      $submenu.show();
    } else {
      $submenu.hide();
      // Clear any selected options in the submenu
      $submenu.find('input[type="checkbox"]').prop("checked", false);

      // Clear the corresponding filter arrays
      if ($(this).val() === "Hanging & Hoop") {
        selectedFilters["hangingType"] = [];
      } else if ($(this).val() === "Diamond Studs") {
        selectedFilters["studSize"] = [];
      } else {
        selectedFilters["stones"] = [];
      }
    }
  });

  // When selecting a different parent option, uncheck others
  $(document).on("change", ".fiter-earring-type .parent-option > label > input", function () {
    if (this.checked) {
      // Uncheck all other parent options
      $(".fiter-earring-type .parent-option > label > input").not(this).prop("checked", false);

      // Clear all filters except the current one
      if (!$(this).hasClass("has-submenu")) {
        selectedFilters["hangingType"] = [];
        selectedFilters["studSize"] = [];
        selectedFilters["stones"] = [];
        $(".fiter-earring-type .sub-menu").hide();
      }
    }
  });

  $(earringTypeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(hangingTypeSelector).prop("checked", false);
      $(studSizeSelector).prop("checked", false);
      $(earringColoredGemstoneSelector).prop("checked", false);

      $(earringTypeSelector).not(this).prop("checked", false);
      showOverlay();
    }
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["hangingType"] = [];
      selectedFilters["studSize"] = [];
      selectedFilters["stones"] = [];
      selectedFilters["earringType"] = filterVal;
    } else {
      selectedFilters["earringType"] = [];
    }
    applyFilter();
  });

  $(hangingTypeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(hangingTypeSelector).not(this).prop("checked", false);
      showOverlay();
    }
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["hangingType"] = filterVal;
    } else {
      selectedFilters["hangingType"] = [];
    }
    applyFilter();
  });

  $(studSizeSelector).change(function () {
    if (this.checked) {
      // Uncheck all other checkboxes
      $(studSizeSelector).not(this).prop("checked", false);
      showOverlay();
    }
    //$(this).parents(".dropdown").toggle();

    const filterVal = [$(this).val()];

    if (this.checked) {
      selectedFilters["studSize"] = filterVal;
    } else {
      selectedFilters["studSize"] = [];
    }
    applyFilter();
  });

  const applyFilter = () => {
    localStorage.setItem("filter-handle", handle);

    localStorage.setItem("filters", JSON.stringify(selectedFilters));
    showOverlay();
    const timer = setInterval(() => {
      if (all_products.length > 0) {
        clearInterval(timer);
        if (
          selectedFilters.material.length === 0 &&
          selectedFilters.stones.length === 0 &&
          selectedFilters.price.length === 0 &&
          selectedFilters.designer.length === 0 &&
          selectedFilters.length.length === 0 &&
          selectedFilters.stoneShape.length === 0 &&
          selectedFilters.stoneSize.length === 0 &&
          selectedFilters.diamondColor.length === 0 &&
          selectedFilters.diamondClarity.length === 0 &&
          selectedFilters.certificate.length === 0 &&
          selectedFilters.ringType.length === 0 &&
          selectedFilters.material_band.length === 0 &&
          selectedFilters.stonesDesigner.length === 0 &&
          selectedFilters.gender.length === 0 &&
          selectedFilters.watchMaterial.length === 0 &&
          selectedFilters.movement.length === 0 &&
          selectedFilters.caseSize.length === 0 &&
          selectedFilters.productType.length === 0 &&
          selectedFilters.condition.length === 0 &&
          selectedFilters.earringType.length === 0 &&
          selectedFilters.hangingType.length === 0 &&
          selectedFilters.studSize.length === 0
        ) {
          console.log("rendering all products")
          filter_products = all_products;
        } else {
          filter_products = all_products.filter((p) => {
            if (!p.metafields) return false;

            let materialMatches = true;
            let materialBandMatches = true;
            let stonesMatch = true;
            let priceMatches = true;
            let designerMatches = true;
            let lengthMatches = true;
            let shapeMatches = true;
            let sizeMatches = true;
            let diamondColorMatches = true;
            let diamondClarityMatches = true;
            let certificateMatches = true;
            let ringTypeMatches = true;
            let stonesDesignerMatches = true;
            let genderMatches = true;
            let watchMaterialMatches = true;
            let movementMatches = true;
            let caseSizeMatches = true;
            let productTypeMatches = true;
            let conditionMatches = true;
            let earringTypeMatches = true;
            let hangingTypeMatches = true;
            let studSizeMatches = true;

            // Extract the necessary metafield values
            const material = p.metafields.find((m) => m?.key === "material")?.value;
            const totalSideStones = p.metafields.find((m) => m?.key === "total_side_stones")?.value;
            const sideStone = p.metafields.find((m) => m?.key === "side_gemstones")?.value;
            const centerStone = p.metafields.find((m) => m?.key === "center_stone")?.value;
            const length = p.metafields.find((m) => m?.key === "length_in")?.value;
            const priceMin = parseFloat(p.priceRange?.minVariantPrice?.amount);
            const center_stone_shape = p.metafields.find((m) => m?.key === "center_stone_shape")?.value;
            const side_stones_shape = p.metafields.find((m) => m?.key === "side_stones_shape")?.value;
            const center_stones_size = p.metafields.find((m) => m?.key === "center_stone_weight_ct")?.value;
            const center_stone_color = p.metafields.find((m) => m?.key === "center_stone_color")?.value;
            const center_stone_clarity = p.metafields.find((m) => m?.key === "center_stone_clarity")?.value;
            const certificate = p.metafields.find((m) => m?.key === "certificate")?.value;
            const gender = p.metafields.find((m) => m?.key === "gender")?.value;
            const movement = p.metafields.find((m) => m?.key === "movement")?.value;
            const caseSize = p.metafields.find((m) => m?.key === "case_size_mm")?.value;
            const stud1Type = p.metafields.find((m) => m?.key === "earring_1_gemstone_1_type")?.value;
            const stud2Type = p.metafields.find((m) => m?.key === "earring_2_gemstone_2_type_")?.value;
            const stud1Size = p.metafields.find((m) => m?.key === "stud_1_size_ct")?.value;
            const stud2Size = p.metafields.find((m) => m?.key === "stud_2_size_ct")?.value;
            const studCombinedSize = p.metafields.find((m) => m?.key === "earring_1_gemstone_1_total_weight_cttw_")?.value;

            // Check Material filter
            if (selectedFilters["material"].length > 0) {
              if (selectedFilters["material"][0] === "All Others") {
                materialMatches = material && !materalfilters["Gold"].includes(JSON.parse(material)[0]);
              } else {
                materialMatches = material && selectedFilters["material"].includes(JSON.parse(material)[0]);
              }
            }

            // Check Stones filter
            console.log(selectedFilters["stones"])
            if (selectedFilters["stones"].length > 0) {
              if (selectedFilters["stones"].includes("Multi-Type")) {
                stonesMatch = sideStone && centerStone && sideStone !== centerStone;
              } else if (selectedFilters["stones"].includes("None")) {
                stonesMatch =
                  !sideStone &&
                  !centerStone &&
                  !totalSideStones &&
                  stoneMatchesNone(p.title, selectedFilters["stones"]) &&
                  stoneMatchesNone(p.bodyHTML, selectedFilters["stones"]);
              } else if (selectedFilters["stones"].includes("Colored Gemstone")) {
                stonesMatch =
                  stoneIsColoredGemstone(sideStone) ||
                  stoneIsColoredGemstone(centerStone) ||
                  stoneIsColoredGemstone(stud1Type) ||
                  stoneIsColoredGemstone(stud2Type) ||
                  containsColoredGemstones(p.title) ||
                  containsColoredGemstones(p.bodyHTML);
              } else {
                stonesMatch =
                  selectedFilters["stones"].includes(stud1Type) ||
                  selectedFilters["stones"].includes(stud2Type) ||
                  selectedFilters["stones"].includes(sideStone) ||
                  selectedFilters["stones"].includes(centerStone) ||
                  stoneMatchesAny(p.title, selectedFilters["stones"]) ||
                  stoneMatchesAny(p.bodyHTML, selectedFilters["stones"]);
              }
            }

            if (selectedFilters["stonesDesigner"].length > 0) {
              if (selectedFilters["stonesDesigner"].includes("None")) {
                stonesDesignerMatches = !sideStone && !centerStone && !totalSideStones && containsNoStones(p.title) && containsNoStones(p.bodyHTML);
              } else if (selectedFilters["stonesDesigner"].includes("Colored Gemstone")) {
                stonesDesignerMatches =
                  stoneIsColoredGemstone(sideStone) ||
                  stoneIsColoredGemstone(centerStone) ||
                  stoneIsColoredGemstone(stud1Type) ||
                  stoneIsColoredGemstone(stud2Type) ||
                  containsColoredGemstones(p.title) ||
                  containsColoredGemstones(p.bodyHTML);
              } else {
                stonesDesignerMatches =
                  selectedFilters["stonesDesigner"].includes(sideStone) ||
                  selectedFilters["stonesDesigner"].includes(centerStone) ||
                  stoneMatchesAny(p.title, selectedFilters["stonesDesigner"]) ||
                  stoneMatchesAny(p.bodyHTML, selectedFilters["stonesDesigner"]);
              }
            }

            // Check Price filter
            if (selectedFilters["price"].length > 0) {
              const priceMinFilter = selectedFilters["price"][0];
              const priceMaxFilter = selectedFilters["price"][1];
              priceMatches = priceMin >= priceMinFilter && priceMin <= priceMaxFilter;
            }

            if (selectedFilters["designer"].length > 0) {
              if (selectedFilters["designer"][0] === "no") {
                designerMatches = p.vendor === "ED Marshall";
              }
              if (selectedFilters["designer"][0] === "yes") {
                designerMatches = p.vendor !== "ED Marshall";
              }
            }

            if (selectedFilters["length"].length > 0) {
              if (selectedFilters["length"][0].includes("-")) {
                const base = selectedFilters["length"][0].replace("-", "");
                lengthMatches = length && parseFloat(length) < parseFloat(base);
              }
              if (selectedFilters["length"][0] === "+") {
                const base = selectedFilters["length"][0].replace("+", "");
                lengthMatches = length && parseFloat(length) >= parseFloat(base);
              }
            }

            if (selectedFilters["stoneShape"].length > 0) {
              if (selectedFilters["stoneShape"].includes("Others")) {
                const others = [
                  "Asscher",
                  "Baguette",
                  "Cabochon",
                  "European",
                  "Fancy",
                  "Marquise",
                  "Multi",
                  "Old Mine",
                  "Rectangle",
                  "Rose",
                  "Single Cut",
                  "Square",
                  "Trapezoid",
                  "Trillion",
                  "Baroque",
                  "Crisscut",
                  "Triangle",
                  "Briolette",
                  "Free Form",
                  "Octagon",
                  "Clover",
                  "Carré Cut",
                  "Irregular Shapes",
                  "Step Cut",
                  "Bullet",
                ];
                const filters = [...selectedFilters["stoneShape"], ...others];
                shapeMatches = filters.includes(center_stone_shape) || filters.includes(side_stones_shape);
              } else {
                shapeMatches =
                  selectedFilters["stoneShape"].includes(center_stone_shape) || selectedFilters["stoneShape"].includes(side_stones_shape);
              }
            }

            if (selectedFilters["diamondColor"].length > 0) {
              const filter = selectedFilters["diamondColor"];

              diamondColorMatches = filter.includes(center_stone_color);
            }

            if (selectedFilters["diamondClarity"].length > 0) {
              const filter = selectedFilters["diamondClarity"];

              diamondClarityMatches = filter.includes(center_stone_clarity);
            }

            if (selectedFilters["certificate"].length > 0) {
              const filter = selectedFilters["certificate"];

              if (filter[0] === "GIA") {
                certificateMatches = !!certificate && JSON.parse(certificate)[0] === "GIA";
              }

              if (filter[0] === "Other") {
                certificateMatches = !!certificate && JSON.parse(certificate)[0] !== "GIA";
              }

              if (filter[0] === "Uncertified") {
                certificateMatches = !certificate || JSON.parse(certificate)[0] === "None" || JSON.parse(certificate)[0] === "No Lab";
              }
            }

            if (selectedFilters["ringType"].length > 0) {
              const filter = selectedFilters["ringType"];

              if (filter[0] === "Engagement Rings") {
                ringTypeMatches = p.productType === "Engagement Ring";
              }

              if (filter[0] === "Women Wedding") {
                ringTypeMatches = !!gender && JSON.parse(gender)[0] === "Women's";
              }

              if (filter[0] === "Men Wedding") {
                ringTypeMatches = !!gender && JSON.parse(gender)[0] === "Men's";
              }
            }

            if (selectedFilters["material_band"].length > 0) {
              const filter = selectedFilters["material_band"];
              if (filter[0] === "White Gold") {
                materialBandMatches = material && material.includes("White Gold");
              }

              if (filter[0] === "Yellow Gold") {
                materialBandMatches = material && material.includes("Yellow Gold");
              }

              if (filter[0] === "All Others") {
                materialBandMatches = material && !material.includes("Yellow Gold") && !material.includes("White Gold");
              }
            }

            if (selectedFilters["gender"].length > 0) {
              const filter = selectedFilters["gender"];

              genderMatches = !!gender && JSON.parse(gender)[0] === filter[0];
            }

            if (selectedFilters["watchMaterial"].length > 0) {
              const filter = selectedFilters["watchMaterial"];

              watchMaterialMatches = material && filter.includes(JSON.parse(material)[0]);
            }

            if (selectedFilters["movement"].length > 0) {
              const filter = selectedFilters["movement"];
              if (filter[0] === "Others") {
                const f = ["Eco Drive", "Solar", "Electrostatic"];
                movementMatches = movement && f.includes(movement);
              } else {
                movementMatches = movement && filter.includes(movement);
              }
            }

            if (selectedFilters["caseSize"].length > 0) {
              const filter = selectedFilters["caseSize"];
              const min = parseFloat(filter[0].split("~")[0]);
              const max = parseFloat(filter[0].split("~")[1]);
              caseSizeMatches = min < parseFloat(caseSize) && parseFloat(caseSize) < max;
            }

            if (selectedFilters["productType"].length > 0) {
              const filter = selectedFilters["productType"];
              if (filter[0] === "Others") {
                const f = ["Rings", "Necklaces", "Cufflinks", "Pocket Knives", "Pocket Knife"];
                productTypeMatches = !f.includes(p.productType);
              } else if (filter[0] === "Pocket Knives") {
                const f = ["Pocket Knives", "Pocket Knife"];
                productTypeMatches = f.includes(p.productType);
              } else {
                productTypeMatches = p.productType === filter[0];
              }
            }

            if (selectedFilters["condition"].length > 0 && selectedFilters["condition"].length !== 2) {
              const filter = selectedFilters["condition"][0];
              conditionMatches = p.tags && Array.isArray(p.tags) && p.tags.includes(filter);
            }

            if (selectedFilters["earringType"].length > 0) {
              const filter = selectedFilters["earringType"][0];
              // Then check for colored gemstones in metafields and text
              const hasColoredGemstonesInMetafields =
                stoneIsColoredGemstone(centerStone) ||
                stoneIsColoredGemstone(sideStone) ||
                stoneIsColoredGemstone(stud1Type) ||
                stoneIsColoredGemstone(stud2Type);
              const hasColoredGemstonesInText =
                containsColoredGemstones(p.title) || (typeof p.bodyHTML === "string" && containsColoredGemstones(p.bodyHTML));
              // First check that it is a stud
              const hasStudInTitle = p.title.toLowerCase().includes("stud");
              const hasStudInBody = typeof p.bodyHTML === "string" && p.bodyHTML.toLowerCase().includes("stud");
              const isStud = hasStudInTitle || hasStudInBody;

              const hasColoredGemstones = hasColoredGemstonesInMetafields || hasColoredGemstonesInText;

              if (filter === "Hanging & Hoop") {
                // First check that it's not a stud
                const hasStudInTitle = p.title.toLowerCase().includes("stud");
                const hasStudInBody = typeof p.bodyHTML === "string" && p.bodyHTML.toLowerCase().includes("stud");
                const isNotStud = !(hasStudInTitle || hasStudInBody);

                if (selectedFilters["hangingType"].length > 0) {
                  const hangingFilter = selectedFilters["hangingType"][0];
                  if (hangingFilter === "No Stones") {
                    earringTypeMatches = isNotStud && !sideStone && !centerStone && !totalSideStones;
                  } else if (hangingFilter === "Diamonds") {
                    earringTypeMatches = isNotStud && (sideStone === "Diamond" || centerStone === "Diamond");
                  }
                } else {
                  earringTypeMatches = isNotStud;
                }
              } else if (filter === "Diamond Studs") {
                // First check that it is a stud and has diamonds
                const hasDiamonds = centerStone?.toLowerCase() === "diamond" || stud1Type === "Diamond" || stud2Type === "Diamond";
                earringTypeMatches = isStud && hasDiamonds;
                if (selectedFilters["studSize"].length > 0) {
                  const [min, max] = selectedFilters["studSize"][0].split("~").map(Number);

                  const totalStudWeight = studCombinedSize ? studCombinedSize || 0 : stud1Size || 0 + stud2Size || 0;

                  sizeMatches = totalStudWeight >= min && totalStudWeight <= max;
                }

              } else if (filter === "Colored Gemstone") {
                earringTypeMatches = hasColoredGemstones;
              }
            }

            // Return true if all conditions match
            const matches =
              materialMatches &&
              stonesMatch &&
              priceMatches &&
              designerMatches &&
              lengthMatches &&
              shapeMatches &&
              sizeMatches &&
              diamondColorMatches &&
              diamondClarityMatches &&
              certificateMatches &&
              ringTypeMatches &&
              materialBandMatches &&
              stonesDesignerMatches &&
              genderMatches &&
              watchMaterialMatches &&
              movementMatches &&
              caseSizeMatches &&
              productTypeMatches &&
              conditionMatches &&
              earringTypeMatches &&
              hangingTypeMatches &&
              studSizeMatches;

            return matches;
          });
          
          // Sort products by price: highest to lowest
          filter_products.sort((a, b) => {
            const priceA = parseFloat(a.priceRange?.minVariantPrice?.amount || 0);
            const priceB = parseFloat(b.priceRange?.minVariantPrice?.amount || 0);
            return priceB - priceA; // Descending order (highest first)
          });
        }
        const products = filter_products.slice(PRODUCTS_PER_PAGE * (currentPage - 1), currentPage * PRODUCTS_PER_PAGE);

        const totalPages = Math.ceil(filter_products.length / PRODUCTS_PER_PAGE);
        if (totalPages > 1) {
          $(".Pagination__Nav").show();
          $(".Pagination__Nav>a").eq(-2).text(totalPages);

          $(".Pagination__Nav>.Pagination__NavItem").each(function (i, el) {
            if (totalPages - i < 1) $(el).hide();
            else $(el).show();
          });

          $(".Pagination__Nav>a").eq(-1).show();
        } else {
          $(".Pagination__Nav").hide();
        }

        if (products.length > 0) {
          $(".EmptyState").hide();
        } else {
          $(".EmptyState").show();
        }
        renderProducs(products);

        scrollIntoView();
        setTimeout(() => {
          hideOverlay();
        }, 1000);
      }
    }, 500);
  };

  const renderProducs = (products) => {
    const productTiles = $(".ProductList.ProductList--grid>div");

    productTiles.each((i, el) => {
      if (!products[i]) {
        $(el).hide();
        return;
      }
      $(el).show();
      $(el).find("a").attr("href", products[i].onlineStoreUrl);

      const images = (products[i].images.edges || []).map((img) => img.node.url);

      if (images[1]) {
        $(el).find(".ProductItem__Image--alternate").attr("src", images[1]);
        $(el).find(".ProductItem__Image--alternate").attr("data-srcset", generateSrcset(images[1]));
        $(el).find(".ProductItem__Image--alternate").attr("srcset", generateSrcset(images[1]));
      } else {
        $(el).find(".ProductItem__Image--alternate").attr("src", images[0]);
        $(el).find(".ProductItem__Image--alternate").attr("data-srcset", generateSrcset(images[0]));
        $(el).find(".ProductItem__Image--alternate").attr("srcset", generateSrcset(images[0]));
      }

      $(el).find(".ProductItem__Image:not(.ProductItem__Image--alternate)").attr("src", images[0]);
      $(el).find(".ProductItem__Image:not(.ProductItem__Image--alternate)").attr("data-srcset", generateSrcset(images[0]));
      $(el).find(".ProductItem__Image:not(.ProductItem__Image--alternate)").attr("srcset", generateSrcset(images[0]));

      $(el).find("h2.ProductItem__Title>a").text(products[i].title);
      $(el)
        .find(".ProductItem__Price.Price")
        .text(`${formatCurrency(products[i].priceRange.minVariantPrice.amount)}`);

      // Fix image alignment - remove inline padding-bottom and apply fixed height
      const $wrapper = $(el).find(".ProductItem__ImageWrapper");
      const $aspectRatio = $wrapper.find(".AspectRatio");
      
      if ($wrapper.length && $aspectRatio.length) {
        $wrapper.css({
          'height': '320px',
          'display': 'block',
          'overflow': 'hidden'
        });
        
        $aspectRatio.css({
          'height': '100%',
          'width': '100%',
          'display': 'flex',
          'align-items': 'flex-end',
          'justify-content': 'center',
          'padding-bottom': '0',
          'position': 'relative',
          'overflow': 'hidden'
        });
        
        // Remove inline padding-bottom if present
        $aspectRatio[0].style.paddingBottom = '0';
        
        // Fix images - ensure they scale down to fit both height and width
        // Apply to both primary and alternate images with identical positioning
        $aspectRatio.find('img').each(function() {
          var $img = $(this);
          var img = this;
          
          // Set constraints to ensure image fits within container
          // Apply same styles to both primary and alternate images
          $img.css({
            'position': 'relative',
            'top': 'auto',
            'left': 'auto',
            'right': 'auto',
            'bottom': '0',
            'height': 'auto',
            'width': 'auto',
            'max-height': '320px',
            'max-width': '100%',
            'object-fit': 'contain',
            'object-position': 'bottom center',
            'display': 'block',
            'margin': '0 auto'
          });
          
          // After image loads, ensure it fits within container
          if (img.complete) {
            ensureImageFits(img, $img, $wrapper);
          } else {
            $(img).on('load', function() {
              ensureImageFits(img, $img, $wrapper);
            });
          }
        });
        
        function ensureImageFits(img, $img, $wrapper) {
          var containerWidth = $wrapper.width();
          var containerHeight = 320;
          var imgWidth = img.naturalWidth || img.width;
          var imgHeight = img.naturalHeight || img.height;
          
          if (imgWidth && imgHeight && containerWidth) {
            // Calculate the scale needed to fit both dimensions
            var widthScale = containerWidth / imgWidth;
            var heightScale = containerHeight / imgHeight;
            var scale = Math.min(widthScale, heightScale, 1); // Don't scale up
            
            var maxW = Math.floor(imgWidth * scale);
            var maxH = Math.floor(imgHeight * scale);
            
            $img.css({
              'max-width': maxW + 'px',
              'max-height': maxH + 'px'
            });
          }
        }
      }
    });
  };

  const scrollIntoView = () => {
    const productContainer = document.querySelector(".CollectionInner__Products");

    productContainer.style.scrollMarginTop = "200px";
    productContainer.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

  $(".Pagination__NavItem").click(function (e) {
    e.preventDefault();

    const totalPages = Math.ceil(filter_products.length / PRODUCTS_PER_PAGE);
    const page = parseInt($(this).text());
    if (currentPage === page || $(this).text().includes("…") || ($(this).attr("rel") === "next" && currentPage === totalPages)) return;

    if (!page) currentPage = currentPage + 1;
    else currentPage = page;

    $(this).parent().find(".Pagination__NavItem.is-active").removeClass("is-active").css("cursor", "pointer");
    if (page) {
      $(this).addClass("is-active");
      $(this).css("cursor", "default");
    }

    showOverlay();
    scrollIntoView();

    const timer = setInterval(() => {
      if (all_products.length > 0) {
        clearInterval(timer);
        var ps = filter_products.length > 0 ? filter_products : all_products;
        const products = ps.slice(PRODUCTS_PER_PAGE * (currentPage - 1), currentPage * PRODUCTS_PER_PAGE);
        renderProducs(products);
        setTimeout(() => {
          hideOverlay();
        }, 1000);
      }
    }, 500);
  });

  if (storageHandle === handle) {
    setTimeout(() => {
      var checkedBoxes = $('input[type="checkbox"]:checked');

      checkedBoxes.each(function () {
        $(this).parents(".dropdown").slideDown();
      });
    }, [1000]);

    applyFilter();
    localStorage.removeItem("filter-handle");
  } else {
    localStorage.removeItem("filter-handle");
    localStorage.removeItem("filters");
    selectedFilters = filter_initVal;
  }
});

const showOverlay = () => {
  const spinnerOverlay = document.querySelector(".spinner-overlay");

  // Show the spinner
  spinnerOverlay.classList.add("show");
};

const hideOverlay = () => {
  const spinnerOverlay = document.querySelector(".spinner-overlay");

  // Show the spinner
  spinnerOverlay.classList.remove("show");
};

const formatCurrency = (value, currency = "USD", locale = "en-US") => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: value % 1 ? 2 : 0, // Show decimal places only if the value has them
    maximumFractionDigits: 2,
  }).format(value);
};

function generateSrcset(baseUrl, sizes = [200, 300, 400, 600, 800, 900, 1000, 1200]) {
  if (!baseUrl) return [];
  // Find the file extension, e.g., ".jpg", ".png"
  const extensionIndex = baseUrl.lastIndexOf(".");
  const queryIndex = baseUrl.indexOf("?");
  const extension = baseUrl.substring(extensionIndex, queryIndex !== -1 ? queryIndex : baseUrl.length);

  // Base URL without dimensions and without the file extension
  const baseWithoutExtension = baseUrl.substring(0, extensionIndex);

  // Generate srcset string
  const srcset = sizes
    .map((size) => {
      return `${baseWithoutExtension}_${size}x${extension} ${size}w`;
    })
    .join(", ");

  return srcset;
}

async function fetchAllProductsInCollection(collectionHandle, metafieldValue) {
  let allProducts = [];
  let hasNextPage = true;
  let cursor = null;

  while (hasNextPage) {
    const query = `
      {
          collection(handle: "${collectionHandle}") {
              id
              products(
                  filters: {productMetafield: {namespace: "custom", key: "material", value: "${metafieldValue}"}}
                  first: ${GRAPHQL_PAGE_SIZE}${cursor ? `, after: "${cursor}"` : ""}
              ) {
                  edges {
                      node {
                          id
                          metafield(key: "material", namespace: "custom") {
                              value
                          }
                      }
                  }
                  pageInfo {
                      hasNextPage
                      endCursor
                  }
              }
          }
      }`;

    try {
      const response = await fetch(GRAPHQL_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({
          query,
        }),
      });

      const jsonResponse = await response.json();

      if (!jsonResponse.data || !jsonResponse.data.collection) {
        console.error("Collection not found or no data returned for the collection handle:", collectionHandle);
        break;
      }

      const products = jsonResponse.data.collection.products.edges.map((edge) => edge.node);
      allProducts = allProducts.concat(products);

      // Check if there's a next page
      hasNextPage = jsonResponse.data.collection.products.pageInfo.hasNextPage;
      cursor = jsonResponse.data.collection.products.pageInfo.endCursor;
    } catch (error) {
      console.error("Error fetching products:", error);
      break;
    }
  }

  return allProducts;
}

async function fetchAllProducts(collectionHandle) {
  let allProducts = [];
  let hasNextPage = true;
  let cursor = null;

  while (hasNextPage) {
    const query = `
      {
          collection(handle: "${collectionHandle}") {
              id
              products(
                  first: ${GRAPHQL_PAGE_SIZE}${cursor ? `, after: "${cursor}"` : ""}
              ) {
                  edges {
                      node {
                          id
                          tags
                          metafields(
                            identifiers: [{key: "total_side_stones", namespace: "custom"},{key: "material", namespace: "custom"}, {key: "side_gemstones", namespace: "custom"},
                            {key: "center_stone", namespace: "custom"}, {key: "length_in", namespace: "custom"},
                            {key: "center_stone_shape", namespace: "custom"}, {key: "side_stones_shape", namespace: "custom"},
                            {key: "center_stone_weight_ct", namespace: "custom"}, {key: "center_stone_color", namespace: "custom"},
                            {key: "center_stone_clarity", namespace: "custom"}, {key: "certificate", namespace: "custom"}, 
                            {key: "gender", namespace: "custom"}, {key: "movement", namespace: "custom"}, {key: "case_size_mm", namespace: "custom"},
                            {key: "earring_1_gemstone_1_total_weight_cttw_", namespace: "custom"}, {key: "earring_1_gemstone_1_type", namespace: "custom"},
                            {key: "earring_2_gemstone_2_type_", namespace: "custom"}, {key: "stud_1_size_ct", namespace: "custom"},
                            {key: "stud_2_size_ct", namespace: "custom"}
                            ]
                          ) {
                            type
                            value
                            key
                          }
                          onlineStoreUrl
                          images(first: 2) {
                            edges {
                              node {
                                url
                              }
                            }
                          }
                          title
                          description
                          priceRange {
                            minVariantPrice {
                              amount
                              currencyCode
                            }
                          }
                          vendor
                          productType
                      }
                  }
                  pageInfo {
                      hasNextPage
                      endCursor
                  }
              }
          }
      }`;

    try {
      // Validate configuration before making request
      if (!STOREFRONT_ACCESS_TOKEN || STOREFRONT_ACCESS_TOKEN === 'ad47b31ff49e5f41b2198d96e1b9e1e6') {
        console.warn('Filter System: Using default Storefront token. Please update SHOPIFY_DOMAIN and STOREFRONT_ACCESS_TOKEN at the top of this file for production use.');
      }

      const response = await fetch(GRAPHQL_API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({
          query,
        }),
      });

      const jsonResponse = await response.json();

      if (!jsonResponse.data || !jsonResponse.data.collection) {
        console.error("Collection not found or no data returned for the collection handle:", collectionHandle);
        break;
      }

      const products = jsonResponse.data.collection.products.edges.map((edge) => edge.node);
      allProducts = allProducts.concat(products);

      // Check if there's a next page
      hasNextPage = jsonResponse.data.collection.products.pageInfo.hasNextPage;
      cursor = jsonResponse.data.collection.products.pageInfo.endCursor;
    } catch (error) {
      console.error("Error fetching products:", error);
      break;
    }
  }

  return allProducts;
}
